import { Box, Button, Flex } from '@chakra-ui/react'
import { faCirclePlay } from '@fortawesome/free-solid-svg-icons'

import Icon from 'src/components/widgets/Icon/Icon'

const WhiteButton: React.FC<{
  brandColor: string
  onClick: React.MouseEventHandler
}> = ({ brandColor, onClick }) => (
  <Button variant="quaternary" onClick={onClick}>
    <Flex alignItems="center" textAlign="left" w="100%">
      <Box flexGrow={1}>What&apos;s an ItList?</Box>
      <Icon ml={2} icon={faCirclePlay} fontSize="24px" color={brandColor} />
    </Flex>
  </Button>
)

export default WhiteButton
